import { render } from "./AddEditEventTemplate.vue?vue&type=template&id=3212e9b7"
import script from "./AddEditEventTemplate.vue?vue&type=script&lang=js"
export * from "./AddEditEventTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__